export const DeclarationType = {
    component: "component",
    directive: "directive"
};
